// extracted by mini-css-extract-plugin
export default {"root":"Empty_root__TfgLW","tip":"Empty_tip__KY2FN","button":"Empty_button__i7I0d"};